import * as React from "react";
const SvgShop2 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 9H1v13h18v-2H3z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 5V1h-8v4H5v13h18V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3.5L12 15z",
  fill: "currentColor"
}));
export default SvgShop2;